import { render, staticRenderFns } from "./OutEmpWage.vue?vue&type=template&id=71d12b94&"
import script from "./OutEmpWage.vue?vue&type=script&lang=js&"
export * from "./OutEmpWage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports